import { Component, inject, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonComponent } from 'app/shared/button/button.component';
import { DialogData, ButtonData, ButtonAction } from '../dialog-data';
import { DialogComponent } from '../dialog.component';


@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [DialogComponent, ButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  dialog = viewChild(DialogComponent);
  dialogData = inject<DialogData>(MAT_DIALOG_DATA);
  buttons: ButtonData[] = [
    {
      text: 'Confirm',
      action: 'first'
    },
    {
      text: 'Cancel',
      color: 'white',
    },
  ];

  onSubmit(action: ButtonAction | undefined) {
    this.dialog()?.close(action);
  }
}
